import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { twMerge } from "tailwind-merge";
export const inputGroupContext = createContext(false);
function InputGroup(props) {
    return (_jsx(inputGroupContext.Provider, { value: true, children: _jsx("div", { ...props, className: twMerge(["flex", props.className]), children: props.children }) }));
}
function InputGroupText(props) {
    const inputGroup = useContext(inputGroupContext);
    return (_jsx("div", { ...props, className: twMerge([
            "py-2 px-3 bg-slate-100 border shadow-sm border-slate-200 text-slate-600 dark:bg-darkmode-900/20 dark:border-darkmode-900/20 dark:text-slate-400",
            inputGroup &&
                "rounded-none [&:not(:first-child)]:border-l-transparent first:rounded-l last:rounded-r",
            props.className,
        ]), children: props.children }));
}
InputGroup.Text = InputGroupText;
export default InputGroup;
